import {createMachine, assign} from 'xstate'
import {useMachine} from '@xstate/vue'
import {shallowRef} from '@vue/reactivity'
import {useAppStore} from '@/stores'

const setCameraPermissionsContext = assign({
  permissions: () => 'camera',
})

const setMicrophonePermissionsContext = assign({
  permissions: () => 'microphone',
})

const setLocationPermissionsContext = assign({
  permissions: () => 'location',
})

const resetPermissionsContext = assign({
  permissions: () => null,
})

const switchModal = (context, event) => {
  const app = useAppStore()
  const {returnTo, to} = event
  context.returnTo = returnTo
  app.transition('HIDE_DEVICES_MODAL')
  app.transition(to)
}

const checkReturn = (context, event) => {
  const app = useAppStore()
  if (context.returnTo) {
    app.transition('HIDE_DEVICES_MODAL')
    app.transition(context.returnTo)
    delete context.returnTo
  }
}

const machine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5SwC4EMVgHQQJawGMB7AOxLAMwgGJiyKqBtABgF1FQAHI2XFXUhxAAPRAFoAjAE4ATFmYA2ACwAOZgFYFzJVIDsUgMy6ANCACeiCQZm6sK3TOYzn6iTIMGJAXy+nUGbDpySkhqNE5OFnYkEG5efkEY0QQDBTkpBV1dJXVmfVSZBQVTCwQrGztdaRVyhRU0mR8-dEwscM4sADdcMAB3LE4wACcAW3xeUlhqACsiXBIooTi+ARIhZLU5CXq9XScJBVylEstrOWdFXTqZHIldFSaQf1b2rp7+2fnqEbAwfhIoIsYssEmskpZmFYsHU8vpnAZ1EYZCcymcsBdlIcFFIpE4DI9nthXt0+lgfn95lBqGBhHwgVweCtEqBku43JVDjcJJp1OpVCirB4sAYalcLipVPYCS0iRE3qTyf8oFgADZEABG6rM1AAygAVACCACU9QB9ADCBoAMlb6bFGaD1pYbrZmCoPI4ctkCgK0RilFicXjpQE2nKSf1FZSsAQ0CqVdQIEM0L07SDVk6yoj0jIDko9gYlLn1CoBY4JFh8w5FPVIcwMiGXuH3mTfkqY3GE4Qhr8SLAABZoIaUtMOjPgsoBlRYKw1Q64pQ6aQC9TOLCGJzqQzKJFKRuyjoR1sUgEd+PUNWasyj+LjlnO-Tr3OyNQKAxOIornRYBz57bZGxmHxXwnhlMNDxbKNTyTFNqCtABRA0ADV4NNAARI0DQAdRvJkwVAUoJGkdR0TfRQtBUGRcko0xWQ8WxVF0LdUmkIwpD3EDCXA+VIzbaMYN6C8NS1XDHQnKwNHXIwi15dRsglYpzEsK5pyUbYtzcEV7CKfduKPKDlQEnAwAAMzQABXFUUGoDDsNNHV4IQ809VEu8REsGolErdidHrDJmCAxTCJkSj1zuDJV1kIiHk4sDiUgvjoOTfpYDAFUGBszCsPQ+CADEDQAVStFy2CWMdmXchBywMLBeQC7dWP0CQBSLGrcm0QpHDqFQpVi0N4oVRLlW7XsByHSlaE7VyKuSCQAwUYVc08NIDCkaQ5oFIoaqApidARJqnF0gbeJPYaCB7MA+0HYcASEq9pvwyqJJIwwANk+SAwFKo5F0QsbD2NSJEhI7m0G06sB7YghjwU8iBMkzdUNE1TSNeDzQAeSNNCAEkADkAHEHszZgUWYEGILB9tIaIaHo1IRH0YABRRtHMZxgmiYnEmlIQMm+qbDoxnOohOH7UhsBIIgUANTo0FwFU0HVdLqAAWWx80jSZgAJdHcdQ5CDWxq0DQAIQQzn7wQQ5bB8u5uULVxDBRaxshnQo1KLIs1vJslcGF0XxbaWX5cV5W1Y17XddQ3H0bNA2jdN83SuBcrHuSN9p3uSE5vY3PXGdubpxqHEahUXI5I45p+rlIWhhFsXyCDuWFaV7B6ZVgq9VQ8PNcZnW9Ytp6rArPYbmoyFDlLHmzmndx2LuPlYWAquBd9-2G6JYOW-SslzKoagCtxjuu9NHvI4H5OGVvGbLGHn8nByN0J5LAush-VavYnos8h92MfmTLAktpZb1DmAagloVbwUwqaeOxszbwUHunbQlZMgBjUu4e4q0UQhURLVGQeg+RkXcDYX+aB-5oCbiHVu4CDSQOgTHOOSFDZwKTtEK+eFMwKChIKK4y1GL8h5oUKQJFawOHwUUHquhSHkModvNuJBVad1QhAqBBpEG3wOD+bkBw6oYKCogEKbpoQhRyLIeS2JpHDAoWgEBrdd770PsfZRtDVHqLKERBaVRXCHFyHo7BTFpxuAlHsJiGhuQKB9iMIgEA4xYH7LgCAEBLq6h1tlNC8EkLq3gjqU+6M0LWjcUxEihibhKHrFUNwUhnZkWhCWesQMsg6ErqBaugtomxPiYk5JOpUmmgAIpGlyfk20l97TXzTogK4JEF75nwTidQztNC2GUIofBQEgkRP5geMk7SVRxISUkhRPT0bZRUdAxmUC1Y6h1NjXWOSVZ5IKaM9MN8EBXCkLU9w9YgK4iOM7VIXluRKFSAiDQNhMiRN2fsrpRzelnz7lHU0FyjRXJuXcoZTy2FjI4ROLIHzOTvlxKtDQ2hnaFFnpCQo2wDgBW5JCmJezOmHJSSc00Vp0aWj1Lc3GSLLnY2udy+5jyRlYpeRMt5exoTZCXFkLc9Qp6lELIcdcVx7hqBUDiAs9KOkHO6b0jGuM9bOUFRikVZVxmZiyBWewDg1r1EOHcZE09frTKKCFeoRhrBSG1Xs7ovBqFa2xuk3lKL+VotxkK4ZhStDCjSNyMuVRlAmGnlIGodhQVAXdKoKiPq3j+uVoG4N6TMnmmyaawpZcfyJsMGoVcm5nZqGYLU+iORVp1FzX63AAag2oQGeW55qdLXukrBJWZb5Vy5gbYYGcqaIpUQncvFpq8okMrzV25WOosLYz1OaLW-bRWDvEt6SsgFdjAoCkWBt7gpKrg8MoaQDgO34HXWAwtyjdZGq5eih5UaB0WtxWkaEbqPDSFmZCFEHsSKLi3JoewCkfbU1prDeGiNjRmlRhjLGeNCZ-pxZbX6cg71aBLBkHIvJsGdRnBRVc9x70hQQxQGmMNlRwwRuk3GABNFmmH2Y4YPf+y2uZpwdTxNIbEQEbjYNWh87QIocFPwOIurirxEPMawPTfUTNuNs2w4U1IM4nCGFaq4K4+iqplOmZcMp1g5ohSU3FOUqnoxOYBLjKWBp4xEF6KEa07LsoYZ0xzXDYlLYPtqsC92EkHCFgo4Bml7F6zKBqOoHwIFJZJPgDEQk5q8OVTEDkc4qQ+Q4L2PelE+WjC1V0ngQgpBghUByyFvLZSvLuEOEWBNig1K+lzHYKsqbVBqUCrpIIDBICNbcnROwmhXrSF+TsHr1r8zugS8E1Q5MJuvMkLIcrhYPk4lTXi8R9gUtbL0u8Tb4rJCLnK5RnQQYJRjs0D7I8gxRjjFWJl9hTX07SFqnNR+BxwpyUW31vFEoJRAxFC9lsnxHpiszBqj5-5PVZHInUHr5wuoBhm7idwMPKaUku5mMQGRyt3C8gdmtpGJRGFOyvbZ+khqqmEqUb7k3b7TpM1oVa3I8iXp5nNes6J6h4usEWLImyGfncJ6eWM8ZifiQ9tCWQeRitzTfMcQXHgSJ1qR5kPQbgCcnXbAJRXoWVmVnfOtKlO4BTEXkGXIzXtMhpGN8eU3yVjJmUsigc3T1upW8hGtW3wLfQ9TCo4OZ4ujdneOh7-iXvUrpUoP71kYLKxl0yCWJLrEyyhRLHKpwihZPNOU6DE30YRqXTGjdKAafLCu-kLkOaUPSkHBXI+Lc7EAlo52u7gyENGNIfrynATzWFXiHsN5HE2Js1Fm2DFaX8fB8uZY-DBvvNNpXEj4ZwwXJGhx4rwn08a-1Pw8PZbbmhEagVjKfbdZwKET2daTxLANI+Cb5uAiGcc19BrURARAWW1xFFqiMB2l+h8nbSP0Fj9jrgDnIE3zKSLndEJULhW0-GngCh+l5whyYn0DkkiTgPrkDiARlmblASQM0DsFQPqUlDbTM2sEUErHqSOGEU6iIPXkDhsQoNbk3xxC8lHmgw1SaWEWdm+XRFWnfDny4TdE4PgI3lkVAXP03yBiLHvlKRI1EOAMVW2BqkonBVkyqDI3kJIMbh4KoR3hGD3nGzH1y1mnAOFG9CaX0Foy110PqEWhsGfyIgG0sWTCQKBnCzyCojSCAg62TVKComHSCWcCKHrA1UUH8IoTINsXSioOnEXgcE0EcD+nsH8VdmcHdBz3IkojLwcw6D-isSUL4LsJ+0QD0A+S8RpRgwkWakEUyCbTSCzXlWLxf1XiqIAQsLkRULqI5zKCcFsGaOI2EQkX8WUHRCIiyABgomSJqKsJsIgFUM8FdGyEREXA9TfAMHmM8SWMdkcDtSkRgJ2QZSQMhGFHIntmESqEewLgCnRD0CcDUC8QsWuJXR1RhSQO-GkK4URGeO2Bu2nk9RnEXG0C2hsDUiuOXxrihU7VqPZ1eXjS8i4Q3DIg1S3ALmn1cL51bx6jpT+NROfTsTezGFgAmD7FULfDkBxOkPfHxKqWnhsGKT0BsGcDcFAyfXzWwCSW6AIDgEZPuGFBFDqnQSuA0GqXfGFGIhuBxE8G2ClyXW2X+N9SpJ3gAEchhGS+Qfx5x7BxchtGDXAapsiuFjstJBSX0Yw6sGBPtGTvwH1MhqVGjMDFVsgFpUhVctxMg2sGMoZmNN9SdpwMhcw-I8cNUmJsEKcgM8h3xE0gYgJQymM6YN8xjXkAwm1Ic5N9BIdsRjjBFrBrStAlp4041MyR9RiMTxUgZp1z1pJrd8SpNr05SbM0gdBfoNTy8Ogz8183NpZPNvMtjcyrtch1w41YyviCFOyoyfEFJrAyjUsvAgA */
    id: 'state',
    predictableActionArguments: true,
    initial: 'disconnected',
    context: {
      permissions: null,
    },
    states: {
      disconnected: {
        on: {
          connected: 'connected',
        },
      },

      connected: {
        on: {
          app: 'app.view',
        },
      },

      app: {
        type: 'parallel',
        states: {
          view: {
            initial: 'permissions',
            states: {
              permissions: {
                on: {
                  join: 'join',
                },
              },

              join: {
                on: {
                  meeting: 'meeting',
                },
              },

              meeting: {
                // type: 'parallel',
                initial: 'lobby',
                on: {
                  exit: 'exit',
                },
                states: {
                  lobby: {
                    on: {
                      START_CALL: 'call',
                    },
                  },

                  call: {
                    on: {
                      draw: 'draw',
                      screensharing: 'screensharing',
                      lobby: 'lobby',
                    },
                  },

                  draw: {
                    on: {
                      LEAVE_DRAW: 'call',
                      lobby: 'lobby',
                    },
                    states: {
                      default: {
                        on: {
                          DRAW_SELECT: 'select',
                        },
                      },
                      select: {
                        on: {
                          DRAW_DEFAULT: 'default',
                        },
                      },
                    },
                    initial: 'default',
                  },

                  screensharing: {
                    on: {
                      call: 'call',
                      lobby: 'lobby',
                    },
                  },

                  recording: {
                    states: {
                      off: {
                        on: {
                          START_RECORDING: 'on',
                        },
                      },

                      on: {
                        on: {
                          STOP_RECORDING: 'off',
                        },
                      },
                    },

                    initial: 'off',
                  },
                  liveCaption: {
                    states: {
                      off: {
                        on: {
                          START_LIVE_CAPTION: 'on',
                        },
                      },

                      on: {
                        on: {
                          STOP_LIVE_CAPTION: 'off',
                        },
                      },
                    },

                    initial: 'off',
                  },
                },
              },

              exit: {},
            },
          },

          microphone: {
            initial: 'notAvailable',
            states: {
              notAvailable: {
                on: {MICROPHONE_AVAILABLE: 'available'},
              },
              available: {
                initial: 'on',
                on: {MICROPHONE_NOT_AVAILABLE: 'notAvailable'},
                states: {
                  on: {
                    on: {
                      MUTE_MICROPHONE: 'muted',
                    },
                  },
                  muted: {
                    on: {
                      UNMUTE_MICROPHONE: 'on',
                    },
                  },
                },
              },
            },
          },

          camera: {
            initial: 'notAvailable',
            states: {
              notAvailable: {
                on: {
                  CAMERA_AVAILABLE: {
                    actions: [],
                    target: 'available',
                  },
                },
              },
              available: {
                initial: 'on',
                on: {
                  CAMERA_NOT_AVAILABLE: {
                    actions: [],
                    target: 'notAvailable',
                  },
                },
                states: {
                  on: {
                    on: {
                      MUTE_CAMERA: 'muted',
                    },
                  },
                  muted: {
                    on: {
                      UNMUTE_CAMERA: 'on',
                    },
                  },
                },
              },
            },
          },

          modal: {
            initial: 'hidden',
            states: {
              hidden: {
                on: {
                  SHOW_DEVICES_MODAL: 'visible.devices',
                  SHOW_QR_MODAL: 'visible.qr',

                  SHOW_CAMERA_PERMISSIONS_MODAL: {
                    target: 'visible.permissions',
                    actions: ['setCameraPermissionsContext'],
                  },

                  SHOW_MICROPHONE_PERMISSIONS_MODAL: {
                    target: 'visible.permissions',
                    actions: ['setMicrophonePermissionsContext'],
                  },

                  SHOW_LOCATION_PERMISSIONS_MODAL: {
                    target: 'visible.permissions',
                    actions: ['setLocationPermissionsContext'],
                  },

                  SHOW_CONNECTIONS_MODAL: 'visible.connections',

                  SHOW_SLOW_NETWORK_MODAL: 'visible.slowNetwork',

                  SHOW_CONNECTION_STATUS_MODAL: 'visible.connectionStatus',

                  SHOW_PARTICIPANTS_MODAL: 'visible.participants',
                },
              },

              visible: {
                on: {
                  HIDE_PERMISSIONS_MODAL: {
                    target: 'hidden',
                    actions: ['resetPermissionsContext', 'checkReturn'],
                  },

                  HIDE_DEVICES_MODAL: {
                    target: 'hidden',
                  },

                  HIDE_QR_MODAL: 'hidden',

                  HIDE_SLOW_NETWORK_MODAL: 'hidden',

                  HIDE_PARTICIPANTS_MODAL: 'hidden',

                  HIDE_CONNECTION_STATUS_MODAL: 'hidden',

                  SWITCH_MODAL: {
                    actions: 'switchModal',
                  },

                  HIDE_CONNECTIONS_MODAL: {
                    targtet: 'hidden',
                    actions: ['checkReturn'],
                  },
                },
                states: {
                  permissions: {},
                  devices: {},
                  qr: {},
                  connections: {},
                  slowNetwork: {},
                  connectionStatus: {},
                  participants: {},
                },
              },
            },
          },

          recording: {
            states: {
              off: {
                on: {
                  START_RECORDING: 'on',
                  DENY_RECORDING: 'recordingNotAllowed',
                },
              },

              on: {
                on: {
                  STOP_RECORDING: 'off',
                },
              },

              recordingNotAllowed: {
                on: {
                  ALLOW_RECORDING: 'off',
                },
              },
            },

            initial: 'recordingNotAllowed',
          },
          liveCaption: {
            states: {
              off: {
                on: {
                  START_LIVE_CAPTION: 'on',
                  DENY_LIVE_CAPTION: 'liveCaptionNotAllowed',
                },
              },

              on: {
                on: {
                  STOP_LIVE_CAPTION: 'off',
                },
              },

              liveCaptionNotAllowed: {
                on: {
                  ALLOW_LIVE_CAPTION: 'off',
                },
              },
            },

            initial: 'liveCaptionNotAllowed',
          },
        },
      },
    },
  },
  {
    actions: {
      setCameraPermissionsContext,
      setMicrophonePermissionsContext,
      setLocationPermissionsContext,
      resetPermissionsContext,
      switchModal,
      checkReturn,
    },
  }
)

const {state: machineState, send, service} = useMachine(machine)
const state = shallowRef(machineState)

service.subscribe((_state, ...args) => {
  console.info(`AppMachine received event ${_state.event.type}`)
  state.value = _state
})

export default function () {
  return {state, send, service, machine}
}
